export const stringToBoolean = (value?: string | null): boolean | undefined => {
	if (!value) return;
	return typeof value === "string"
		? ["true", "1"].includes(value.toLowerCase())
		: Boolean(value);
};
